import ModulePage from "../ModulePage/ModulePage";

const ProfessionsRegulades = () => <ModulePage />;

export default ProfessionsRegulades;
